import Company from './Company';
import LoadUserData from '../../LoadUserData';

export const CompanyConfig = {
  settings: {
    layout: {
      config: {}
    }
  },
  auth: ['super', 'admin'],//['admin','staff']
  routes: [
    {
      path: '/dashboard',
      component: LoadUserData(Company)
    }
  ]
};
